import { useEffect } from "react";
import { motion, useMotionValue, useSpring, useTransform, useScroll } from "framer-motion";

const NODES = [
  { x: 90, y: 90, l: "Cittadini" },
  { x: 300, y: 60, l: "Strutture sanitarie" },
  { x: 70, y: 310, l: "Aziende" },
  { x: 315, y: 340, l: "Organizzazioni" },
  { x: 200, y: 420, l: "Partner operativi" },
];

export const NetworkVisual = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-1, 1], [8, -8]), { stiffness: 60, damping: 18 });
  const ry = useSpring(useTransform(mx, [-1, 1], [-10, 10]), { stiffness: 60, damping: 18 });
  const { scrollY } = useScroll();
  const py = useTransform(scrollY, [0, 600], [0, 90]);

  useEffect(() => {
    const onMove = (e) => {
      mx.set((e.clientX / window.innerWidth) * 2 - 1);
      my.set((e.clientY / window.innerHeight) * 2 - 1);
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, [mx, my]);

  return (
    <motion.div style={{ y: py }} className="relative mx-auto w-full max-w-[460px] [perspective:1200px]" data-testid="hero-network-visual">
      <motion.div style={{ rotateX: rx, rotateY: ry }} className="relative aspect-[4/4.6] w-full [transform-style:preserve-3d]">
        <svg viewBox="0 0 400 480" className="absolute inset-0 h-full w-full overflow-visible">
          <circle cx="200" cy="230" r="150" fill="none" stroke="#C6AD76" strokeOpacity="0.35" />
          <circle cx="200" cy="230" r="95" fill="none" stroke="#18314F" strokeOpacity="0.1" strokeDasharray="2 6" />
          {NODES.map((n, i) => (
            <motion.line
              key={n.l}
              x1="200" y1="230" x2={n.x} y2={n.y}
              stroke="#18314F" strokeOpacity="0.35" strokeWidth="1"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 1.4, delay: 0.6 + i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            />
          ))}
          {NODES.map((n, i) => (
            <circle key={n.l + "p"} r="3" fill="#C6AD76" className="pulse-dot" style={{ animationDelay: `${i * 0.7}s` }}>
              <animateMotion dur={`${4 + i}s`} repeatCount="indefinite" path={`M${n.x},${n.y} L200,230`} />
            </circle>
          ))}
        </svg>
        {NODES.map((n, i) => (
          <motion.div
            key={n.l}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 1 + i * 0.12 }}
            style={{ left: `${(n.x / 400) * 100}%`, top: `${(n.y / 480) * 100}%`, x: "-50%", y: "-50%", translateZ: 40 }}
            className="absolute"
          >
            <span className="flex items-center gap-2 whitespace-nowrap rounded-full border border-navy/10 bg-white/90 px-3 py-1.5 text-[11px] font-semibold text-navy shadow-[0_6px_20px_rgba(24,49,79,0.10)] backdrop-blur sm:text-xs">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" />
              {n.l}
            </span>
          </motion.div>
        ))}
        <motion.div
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          style={{ left: "50%", top: "47.9%", x: "-50%", y: "-50%", translateZ: 80 }}
          className="absolute"
        >
          <div className="relative flex h-36 w-36 flex-col items-center justify-center rounded-full bg-navy text-center text-white shadow-[0_24px_60px_rgba(24,49,79,0.35)] sm:h-40 sm:w-40">
            <span className="absolute inset-2 rounded-full border border-gold/50" />
            <span className="halo absolute inset-0 rounded-full" />
            <span className="text-[10px] font-semibold uppercase tracking-[0.25em] text-gold">Centrale</span>
            <span className="mt-1 text-sm font-bold tracking-wide">Operativa</span>
            <span className="mt-1 text-[10px] tracking-[0.2em] text-white/70">NEXUS</span>
          </div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};
